export default "__VITE_ASSET__CaZy9R0l__"